import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import '../styles/Footer.css';
import { Link } from "react-router-dom";

function Footer() {
  let date = new Date();
  let year = date.getFullYear();
  return (
    <Container fluid className="footer">
      <Row>
        <Col md="4" className="footer-copywright">
          <h3>Vurtual Design</h3>
        </Col>
        <Col md="4" className="footer-copywright">
          <h3>©{year} <Link to="/privacy-policy">Privacy Policy</Link> </h3>
        </Col>
        <Col md="4" className="footer-body">
          <ul className="footer-icons">
            <li>
            <h3>mail@vurtualdesign.co.uk</h3>
            </li>
          </ul>
        </Col>
      </Row>
    </Container>
  );
}

export default Footer;